// An open Mood/Skin/Settings sheet closes itself if left untouched, so the
// popup returns to the controls instead of sitting on a panel.
export const SHEET_AUTO_CLOSE_MS = 6000;
// Must match the #Slowed width in css/window.css. The native popup document
// is shrink-to-fit, so it has to be pinned to this: the sheet chip rows are
// horizontal scroll containers, and their unclipped intrinsic width would
// otherwise propagate up and make Chrome widen the popup window (to its
// 800px cap) the first time a sheet opens — which it never undoes.
export const POPUP_WIDTH_PX = 525;
export const SHARE_COPY_RESET_MS = 3000;
// How long a mood's name replaces the wordmark after it is applied. Matches
// the skin-logo.css announcement animation.
export const MOOD_ANNOUNCEMENT_MS = 2200;
// How often the popup asks the tab whether audio is running, so the Winamp
// analyser can stop with the music. Tab-direct, so it never wakes the
// background service worker.
export const PLAYBACK_POLL_MS = 1000;
export const HIDDEN_VIDEO_FX_NAMES = ["Pu-241", "Ghost", "Vintage", "WMP"];
// Parked until their loops ship: the modes are wired end to end, they just
// have no sample to play yet. Removing the key here brings the tile back.
export const HIDDEN_AUDIO_MODE_KEYS = ["hotelLounge", "cocktailBar"];

export function normalizeVideoFxs(videoFxs) {
  return Array.isArray(videoFxs) ? videoFxs : [];
}
